import React, { useEffect, useState } from 'react';
import userDetailsStyles from "../../../styles/userDetails/userDetails.module.css";
import appointmentStyles from "../../../styles/userDetails/appointmentScheduler.module.css";


const ViewAppointmentModal = ({appointmentDetails}) => {  
    
    return (

        <div className={`modal fade ${userDetailsStyles["userDetailsModal"]}`} id="viewBranchModal" tabIndex="-1" aria-labelledby="viewBranchModalLabel" aria-hidden="true">
            <div className={`modal-dialog ${userDetailsStyles["modal-dialog"]}`}>
                <div className={`modal-content ${userDetailsStyles["modal-content"]}`}>
                    <div className={`modal-header ${userDetailsStyles["modal-header"]}`}>
                        <h5 id="viewBranchModalLabel" className={`modal-title ${userDetailsStyles["modal-title"]}`}>View Appointment Details</h5>
                        <button type="button" className={`btn-close ${userDetailsStyles["btn-close"]}`} data-bs-dismiss="modal" aria-label="Close"
                        />
                    </div>
                    <div className={`modal-body ${userDetailsStyles["modal-body"]}`}>
                        <div className={appointmentStyles["detailRow"]}>
                            <span className={appointmentStyles["label"]}>Branch ID:</span>
                            <span className={appointmentStyles["value"]}>{appointmentDetails?.branchID || "-"}</span>
                        </div>

                        <div className={appointmentStyles["detailRow"]}>
                            <span className={appointmentStyles["label"]}>Branch Name:</span>
                            <span className={appointmentStyles["value"]}>{appointmentDetails?.branchName || "-"}</span>
                        </div>

                        <div className={appointmentStyles["detailRow"]}>
                            <span className={appointmentStyles["label"]}>Email:</span>
                            <span className={appointmentStyles["value"]}>{appointmentDetails?.email || "-"}</span>
                        </div>

                        <div className={appointmentStyles["detailRow"]}>
                            <span className={appointmentStyles["label"]}>Address:</span>
                            <span className={appointmentStyles["value"]}>{appointmentDetails?.address || "-"}</span>
                        </div>

                        <div className={appointmentStyles["detailRow"]}>
                            <span className={appointmentStyles["label"]}>Appointment Info:</span>
                            <span className={appointmentStyles["value"]}>
                                <span>{appointmentDetails?.appointmentDate} - {appointmentDetails?.appointmentTime} ({appointmentDetails?.appoinmentType})</span>                            
                            </span>
                        </div>
                         <div className={appointmentStyles["detailRow"]}>
                            <span className={appointmentStyles["label"]}>Phone No:</span>
                            <span className={appointmentStyles["value"]}>{appointmentDetails?.customerPhone || "-"}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ViewAppointmentModal
